import i18n from "@/i18n";

// Hook-free lookup for UI copy. Swedish source text is the key (namespace "auto");
// pages re-render on language change because DashboardLayout re-renders its Outlet.
export const tx = (sv) => i18n.t(sv, { ns: "auto", defaultValue: sv, keySeparator: false, nsSeparator: false });
